var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 8.40668H12.6668",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 6.8533V11.62C12.6468 13.52 12.1268 14 10.1468 14H3.85352C1.84018 14 1.3335 13.5 1.3335 11.5133V6.8533C1.3335 5.0533 1.7535 4.47331 3.3335 4.37997C3.4935 4.37331 3.66685 4.36664 3.85352 4.36664H10.1468C12.1601 4.36664 12.6668 4.86664 12.6668 6.8533Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 4.48667V9.14667C14.6668 10.9467 14.2468 11.5267 12.6668 11.62V6.85333C12.6668 4.86667 12.1601 4.36667 10.1468 4.36667H3.85352C3.66685 4.36667 3.4935 4.37333 3.3335 4.38C3.3535 2.48 3.87352 2 5.85352 2H12.1468C14.1601 2 14.6668 2.5 14.6668 4.48667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.8734H4.64665",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07324 11.8734H8.36658",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPaymentIcon);
export default __webpack_public_path__ + "static/media/card-payment-icon.142bf6712b4a4107974b6d8af3e7a843.svg";
export { ForwardRef as ReactComponent };